<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12 5L12 4C12 2.89543 11.1046 2 10 2L4 2C2.89543 2 2 2.89543 2 4L2 12C2 13.1046 2.89543 14 4 14L10 14C11.1046 14 12 13.1046 12 12L12 11"
        stroke="var(--bg-color)" stroke-width="2" />
    <path d="M15 8.02541L6 7.98588M6 7.98588L9 11M6 7.98588L9 5" stroke="var(--bg-color)" stroke-width="2" />
</svg>

